import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import './index.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "aos/dist/aos.css"; 
import "react-typed/dist/animatedCursor.css";

import AOS from "aos";
AOS.init();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
